"use client";

import { forwardRef, type ComponentProps } from "react";
import { Button } from "@/components/ui/button";
import { useDemoPopup } from "@/contexts/demo-popup-context";
import { trackEvent } from "@/lib/analytics";
import posthog from "posthog-js";

type ButtonProps = ComponentProps<typeof Button>;

interface DemoButtonProps extends Omit<ButtonProps, "onClick"> {
  source?: string;
  children: React.ReactNode;
  onBeforeOpen?: () => void;
}

export const DemoButton = forwardRef<HTMLButtonElement, DemoButtonProps>(
  ({ source = "unknown", children, onBeforeOpen, ...props }, ref) => {
    const { openPopup } = useDemoPopup();

    function handleClick() {
      onBeforeOpen?.();
      trackEvent({
        event: "cta_clicked",
        category: "engagement",
        label: source,
      });
      posthog.capture("cta_clicked", { source });
      openPopup(source);
    }

    return (
      <Button ref={ref} onClick={handleClick} {...props}>
        {children}
      </Button>
    );
  }
);

DemoButton.displayName = "DemoButton";
